/**
 * ErrorBoundary — stops one misbehaving child from blanking a whole section.
 * Used to wrap each collapsible admin drawer's contents so a single panel that
 * throws renders a small inline message instead of an empty drawer.
 */
import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error(`[${this.props.label || "panel"}] render error:`, error, info);
  }

  render() {
    if (this.state.error) {
      return (
        <div
          className="border border-amber-300 bg-amber-50 text-amber-800 text-[12px] p-3 rounded"
          data-testid="panel-error-boundary"
        >
          This panel hit an error and couldn't load{this.props.label ? ` (${this.props.label})` : ""}.
          The other tools below are unaffected. Try reloading the page.
        </div>
      );
    }
    return this.props.children;
  }
}
